<template>
  <div id="app" :class="[{'custom': themeObj.current && themeObj.current !== 'default'}, themeObj.current, themeObj.style]">
    <router-view/>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Theme from './mixins/theme'
import themeUtils from './util/themeUtils'
import storageUtils from './util/storageUtils'
import storageKey from './constants/storageKey'
import {on, off} from 'element-ui/lib/utils/dom'
import browserUtils from './util/browserUtils'
import layoutConstants from './constants/layoutConstants'

export default {
  name: 'App',
  mixins: [Theme],
  computed: {
    ...mapState({
      tabObj: state => state.layout.main.tab,
      accountObj: state => state.account,
      gridConfig: state => state.grid.config
    })
  },
  methods: {
    handleLayoutClick () {
      this.$bus.$emit(layoutConstants.event.LAYOUT_CLICK)
    },
    installEvent () {
      on(document, 'click', this.handleLayoutClick)
    },
    uninstallEvent () {
      off(document, 'click', this.handleLayoutClick)
    }
  },
  mounted () {
    /* ie下部分路由不跳转修复 */
    if (browserUtils.isIE()) {
      on(window, 'hashchange', () => {
        let currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.replace(currentPath)
        }
      })
    }
    /* 修复火狐下拖拽打开新页面问题 */
    on(document.body, 'drop', event => {
      event.preventDefault()
      event.stopPropagation()
    })
    /* 监听相关标签 */
    // on(document.body, 'click', event => {
    //   let target = event.target || event.srcElement
    //   while (target && target.nodeName !== 'HTML') {
    //     if (target.nodeName === 'A') {
    //       let href = target.getAttribute('href')
    //       if (href && href.startsWith('/')) {
    //         event.preventDefault()
    //         this.$store.dispatch('globalActionParams', href).then(params => {
    //           let query = []
    //           if (params) {
    //             Object.entries(params).forEach(([key, val]) => {
    //               if (Array.isArray(val)) {
    //                 val.forEach(v => {
    //                   query.push(`${key}=${v}`)
    //                 })
    //               } else {
    //                 query.push(`${key}=${val}`)
    //               }
    //             })
    //           }
    //           let openUrl
    //           if (query.length) {
    //             if (href.includes('?')) {
    //               openUrl = href + '&' + query.join('&')
    //             } else {
    //               openUrl = href + '?' + query.join('&')
    //             }
    //           } else {
    //             openUrl = href
    //           }
    //           let to = target.getAttribute('target') || '_self'
    //           window.open(openUrl, to)
    //         }).catch(err => {
    //           this.$message({
    //             message: err.message,
    //             type: 'warning',
    //             center: true
    //           })
    //         })
    //       }
    //       break
    //     }
    //     target = target.parentNode
    //   }
    // })
    this.installEvent()
  },
  beforeDestroy () {
    this.uninstallEvent()
  },
  watch: {
    // 修改主题
    'themeObj.current': function (newVal, oldVal) {
      let newTheme = this.getThemeByName(newVal)
      if (newTheme) {
        if (oldVal) {
          let oldTheme = this.getThemeByName(oldVal)
          if (oldTheme) {
            let result = themeUtils.changeTheme(newTheme.themeColor, oldTheme.themeColor)
            if (!result) {
              this.$notify({
                title: '操作失败',
                message: '主题信息有误无法修改',
                type: 'error'
              })
            }
          }
        } else {
          themeUtils.changeTheme(newTheme.themeColor)
        }
      }
    },
    // 记录首页选项卡
    'tabObj.options': {
      handler: function (newVal) {
        if (this.accountObj.loginId) {
          storageUtils.setItem(this.accountObj.loginId || '_anonymous', storageKey.MAIN_TAB_OPTIONS, newVal)
        }
      },
      deep: true
    },
    // 记录表格配置
    'gridConfig': {
      handler: function (newVal) {
        if (this.accountObj.loginId) {
          storageUtils.setItem(this.accountObj.loginId || '_anonymous', storageKey.TEMPLATE_GRID_CONFIG, newVal)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  /* 引入样式 */
  @use "styles/index" as *;
  @use "themes/index" as *;

  #app {
    width: 100%;
    height: 100%;
  }
</style>
